export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const SET_IS_AUTH = "SET_IS_AUTH";

export const initialState = {
  isAuth: false,
  admin: {},
};

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_IS_AUTH:
      return {
        ...state,
        isAuth: true,
      };

    case LOGIN:
      localStorage.setItem("id", payload.id);
      localStorage.setItem("isAuth", true);
      return {
        ...state,
        isAuth: true,
        admin: payload,
      };

    case LOGOUT:
      localStorage.removeItem("id");
      localStorage.removeItem("isAuth");
      return {
        ...state,
        isAuth: false,
        admin: {},
      };

    case UPDATE_PROFILE:
      console.log(payload);
      return {
        ...state,
        admin: {
          ...state.admin,
          ...payload,
        },
      };

    default:
      return state;
  }
};
